export default function BCPAssessmentDocumentController(
  $q,
  $rootScope,
  $scope,
  alerts,
  bcpDataService,
  bcpSharedModelService,
  confirmDialog,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  bcpEditAssessmentDocumentDialog
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Assessment Document Added';
  vm.isExpanded = false;
  vm.isEditable = true;

  // Attach Event Handlers
  vm.handleEditAssessmentDocument = _handleEditAssessmentDocument;

  vm.handleUnattachAssessmentDocument = _handleUnattachAssessmentDocument;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleEditAssessmentDocument($event) {
    ssDialogService.dialogs.bcp.editDocumentAttachmentDialog = ssDialogService.alert(
      bcpEditAssessmentDocumentDialog.getOptions($event, {
        assessment: vm.assessment,
        document: vm.assessmentDocument,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.editDocumentAttachmentDialog);
  }

  function _handleUnattachAssessmentDocument($event) {
    ssDialogService.dialogs.bcp.deleteAssessmentDocumentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Remove Assessment Document?',
        message: `Are you sure you want to remove document "${vm.assessmentDocument.displayName}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.bcp.deleteAssessmentDocumentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return bcpDataService.detachAssessmentDocument(vm.assessmentDocument.bcpAssessmentDocumentId).then(() => {
      alerts.success('The document has been removed successfully.');
      $rootScope.$broadcast('refreshBCPAssessmentDocuments', { assessmentId: vm.assessmentDocument.assessmentId });
      _closeDeleteDialog();
    }).catch(() => {
      alerts.error('An error occurred while removing the document.');
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.deleteAssessmentDocumentConfirmDialog);
  }
}

BCPAssessmentDocumentController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'bcpDataService',
  'bcpSharedModelService',
  'confirmDialog',
  'docDataService',
  'loaderService',
  'orgDataService',
  'ssDialogService',
  'bcpEditAssessmentDocumentDialog'
];
